import React, { useState } from 'react';
import { Box, Typography, Paper, Container, Slider, Stack } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

const Zoomer: React.FC = () => {
  const [zoomLevel, setZoomLevel] = useState<number>(50);

  const handleZoomChange = (event: Event, newValue: number | number[]) => {
    setZoomLevel(newValue as number);
  };

  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Zoomer
        </Typography>
        <Box 
          sx={{ 
            width: '100%', 
            height: '150px', 
            bgcolor: 'grey.200', 
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transform: `scale(${zoomLevel / 50})`,
            transition: 'transform 0.3s ease'
          }}
        >
          <Typography variant="body1">
            Zoom Preview Area
          </Typography>
        </Box>
        
        <Stack 
          direction="row" 
          spacing={2} 
          alignItems="center" 
          sx={{ width: '100%', mt: 2 }}
        >
          <ZoomOutIcon />
          <Slider
            value={zoomLevel}
            onChange={handleZoomChange}
            aria-labelledby="zoom-slider"
            min={10}
            max={100}
          />
          <ZoomInIcon />
        </Stack>
      </Paper>
    </Container>
  );
};

export default Zoomer; 